import * as englishLocaleData from 'react-intl/locale-data/en';
import * as japaneseLocaleData from 'react-intl/locale-data/ja';
import * as chineseLocaleData from 'react-intl/locale-data/zh';
import * as vietnamLocaleData from 'react-intl/locale-data/vi';

import * as ja from './assets/i18n/ja.json';
import * as en from './assets/i18n/en.json';
import * as zh_tw from './assets/i18n/zh-tw.json';
import * as vi from './assets/i18n/vi.json';

import { addLocaleData } from 'react-intl';

addLocaleData([...japaneseLocaleData, ...englishLocaleData, ...chineseLocaleData, ...vietnamLocaleData]);

let navigator: any = window.navigator;
let langs = navigator.languages || [];
console.log(langs);
langs = langs.filter((lang: string) => {
  return lang.substr(0, 2).match(/ja|en|zh|vi/);
});
let userLang = (navigator.browserLanguage || langs[0] || navigator.language || navigator.userLanguage).substr(0, 2);
if (userLang === 'zh' && (
    navigator.browserLanguage ||
    langs[0] ||
    navigator.language ||
    navigator.userLanguage).toLowerCase() === 'zh-tw'
) {
  userLang = 'zh-tw';
}

export const messages = {
  'ja': ja,
  'en': en,
  'zh-tw': zh_tw,
  'vi': vi
};

export const lang  = /(ja|zh\-tw|vi)/gi.test(userLang) ? userLang : 'en';



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/i18n.ts